import React, { useCallback, useMemo } from 'react';
import AppBarMenuLink from 'components/appbar/desktop/AppBarMenuLink';
import { useSelector } from 'react-redux';
import { selectLocale } from 'models/localization';
import { useMediaQuery } from '@material-ui/core';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import getRemappedLinks from 'models/helpers/getRemappedLinks';
import { CustomPageGroup } from 'models/types/customPage';

const DesktopAppBarCustomPageDropdown = ({ pages, name, title }: CustomPageGroup) => {
  const locale = useSelector(selectLocale);
  const isDesktop = useMediaQuery('(min-width: 960px)');
  const deviceName = isDesktop ? 'desktop' : 'mobile';

  const handleClick = useCallback((key) => {
    window.trackingEventToFirebase(null, 'MainMenu_Click', 'CustomPage', key);
  }, []);

  const remappedLinks = useMemo(() => getRemappedLinks(pages, deviceName, locale, handleClick), [pages, deviceName, locale, handleClick]);

  const isActive = useCallback((location: Location) => {
    const flattened: Record<string, boolean> = pages.flatMap((page) => Object.values(page.path)).reduce((acc, curr: string) => {
      acc[curr] = true;
      return acc;
    }, {}) as Record<string, boolean>;
    return location.pathname in flattened;
  }, [pages]);

  return (
    <AppBarMenuLink
      htmlId={name}
      showMenu
      isActive={isActive}
      name={findAvailableLocale(title, locale)}
      subLinks={remappedLinks}
    />
  );
};

export default DesktopAppBarCustomPageDropdown;
